import {
  LifeBroken,
  LifeEmpty,
  LifeFull,
} from '@tymbe/ty-components/illustrations';
import { LifeConstants } from '@tymbe/schema/constants/life_constants';

export const TyLifeScore = ({ lives }: { lives: number }) => {
  const fullLives = Math.min(lives, LifeConstants.maxLives);

  return (
    <div className="flex gap-1 w-[88px] justify-center ">
      {fullLives < 0 && <LifeBroken />}
      {fullLives >= 0 &&
        Array.from({ length: LifeConstants.maxLives }, (_, index) => {
          if (index < fullLives) {
            return <LifeFull key={index} />;
          }
          return <LifeEmpty key={index} />;
        })}
    </div>
  );
};
